/**
 * VerifyEmailPage Component
 */

import { pushNotification } from '../../../../redux/actions/notifications';
import { toggleHeaderVisibility } from '../../../../redux/actions/ui';
import * as actions from '../../../../redux/actions/user';
import { encodeForUrl } from '../../../../utils/url';
import { bw6, dangerous } from '../../../styles/colors';
import './styles.scss';

import { CognitoUserSession } from 'amazon-cognito-identity-js';
import { RouteMatch } from 'found';
import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { connect } from 'react-redux';
import { VelocityTransitionGroup } from 'velocity-react';

import Page from '../../../../containers/Page';
import Button from '../../../atoms/buttons/Button';
import { IconMusicNote } from '../../../atoms/images/Icon';
import Heading from '../../../atoms/text/Heading';
import EmailPasswordForm from '../../../organisms/modals/AuthenticationDrawer/EmailPasswordForm';
import { LoginPagePath } from '../../../pages/account/Login';
import { BrowsePagePath } from '../../browse/Browse';
import { DiscoverPagePath } from '../../browse/Discover';

export const VerifyEmailPagePath = (email: string, code: string) => `/verify?email=${email}&code=${code}`;

interface IOwnDispatchProps {
  pushNotification: (notification: INotificationProps) => void;
  requestVerifyUserEmail: (payload: IVerifyEmailActionPayload) => Promise<any>;
  toggleHeader: (toggle: boolean) => void;
}

type VerifyEmailPageProps =
  & IOwnDispatchProps
  & RouteMatch;

interface IOwnState {
  code?: string;
  email?: string;
  emailConfirmed?: boolean;
  userMustLogIn?: boolean;
}

const classes = new BEM('verify-email');

class VerifyEmailPage extends React.Component<VerifyEmailPageProps, IOwnState> {
  constructor(props: VerifyEmailPageProps) {
    super(props);
    this.state = {
      email: props.location.query.email,
      code: props.location.query.code,
    };
  }

  componentDidMount() {
    const {
      email,
      code,
    } = this.state;

    if (!code || !email) {
      this.props.router.replace(DiscoverPagePath);
    } else {
      this.props.toggleHeader(false);
      this.doVerifyEmail();
    }
  }

  componentDidUpdate(prevProps, prevState: IOwnState) {
    if (prevState.userMustLogIn && !this.state.userMustLogIn) {
      this.doVerifyEmail();
    }
  }

  componentWillUnmount() {
    this.props.toggleHeader(true);
  }

  doVerifyEmail() {
    const {
      email,
      code,
    } = this.state;

    if (code && email) {
      setTimeout(async () => {
        try {
          await this.props.requestVerifyUserEmail({ code, email });
          this.setState({ emailConfirmed: true });
        } catch (error) {
          if (error.name === 'CognitoUserNotFound') {
            this.setState({ userMustLogIn: true });
          } else {
            this.props.pushNotification({
              autoDismiss: false,
              message: error.message,
              state: 'error',
            });
            setTimeout(() => this.props.router.push(DiscoverPagePath), 2000);
          }
        }
      }, 1000);
    }
  }

  onLoginSuccess = (cognitoSession: CognitoUserSession) => {
    const idToken = cognitoSession.getIdToken().getJwtToken();
    const accessToken = cognitoSession.getAccessToken().getJwtToken();
    const state = encodeForUrl({
      stateType: 'EmailVerification',
      email: this.state.email!,
      code: this.state.code!,
    });
    this.props.router.push(`${LoginPagePath}#id_token=${idToken}&access_token=${accessToken}&state=${state}`);
  }

  render() {
    const {
      code,
      email,
      emailConfirmed,
      userMustLogIn,
    } = this.state;
    return (
      <VelocityTransitionGroup
        component={Page}
        id="verify-email"
        enter={{ animation: 'transition.expandIn', duration: 500, delay: 350 }}
        leave={{ animation: 'transition.shrinkOut', duration: 350 }}
        runOnMount
      >
        {emailConfirmed ? (
          <div key="verify-email-success" { ...classes('content') }>
            <Heading is="h2" { ...classes('title') }>Great!</Heading>
            <Heading is="h4" { ...classes('subtitle') }>Your email has been verified!</Heading>
            <Button
              onClick={() => this.props.router.push(BrowsePagePath)}
              icon={<IconMusicNote />}
              label="Browse Music"
              colorScheme="accent"
              size="large"
            />
          </div>
        ) : (userMustLogIn ? (
          <div key="login-form" { ...classes('content', 'form') }>
            <Heading is="h3">Please log in:</Heading>
            <EmailPasswordForm
              form="login-form"
              action="login"
              initialValues={{
                email: this.props.location.query.email,
                password: '',
              }}
              disableOppositeAction
              onSubmitSuccess={this.onLoginSuccess}
              {...classes('login-form') }
            />
          </div>
        ) : (email && code ? (
          <div key="verifying-email" { ...classes('content') }>
            <Heading is="h1" textColor={bw6}>Verifying your email...</Heading>
          </div>
        ) : (
            <div key="verifying-email" { ...classes('content') }>
              <Heading is="h3" textColor={dangerous}>
                Error while verifying your email.<br />Please try again later.
              </Heading>
            </div>
          )))}
      </VelocityTransitionGroup>
    );
  }
}

const ConnectedVerifyEmailPage = connect(
  null,
  (dispatch): IOwnDispatchProps => ({
    pushNotification: (notification) => {
      dispatch(pushNotification(notification));
    },
    requestVerifyUserEmail: (payload) =>
      new Promise((resolve, reject) => {
        dispatch(actions.requestVerifyUserEmail({
          ...payload,
          promise: { resolve, reject },
        }));
      }),
    toggleHeader: (toggle) => {
      dispatch(toggleHeaderVisibility(toggle));
    },
  }),
)(VerifyEmailPage);

export default ConnectedVerifyEmailPage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/account/VerifyEmail/index.tsx